import { MemberUnpaidBill } from "./member-bill.model";

export interface AnnualRegistrationForm {
  workHours: any;// WorkedHour[];
  answers: AnnualRegistrationAnswer[];
  state?: RegistrationFormState;
  memberUnpaidBills?: MemberUnpaidBill[];
  paymentReceipt?: PaymentReceipt;
  pdfDocumentId?: string;
  workAddressesForUpdate: any[];//MemberSecondaryWorkAddress[];
}

export enum RegistrationFormState {
  INITIAL = 'INITIAL',
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  ERROR = 'ERROR',
}

export interface AnnualRegistrationAnswer {
  questionNumber: number;
  year: number;
  value: string;    //ToString() de la valeur
}

export enum QuestionDataType {
  STRING = 'STRING',
  EMAIL = 'EMAIL',
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  YESNO = 'YESNO',
  OTHER = 'OTHER',
}

export enum SectionFormulaire {
  ACTIVITE_PROF_ACTE_DOMAINE = 'ACTIVITE_PROF_ACTE_DOMAINE',
  ACTIVITE_PROF_ACTE_CONDITION = 'ACTIVITE_PROF_ACTE_CONDITION',
  ACTIVITE_PROF_MODALITE_SEDATION = 'ACTIVITE_PROF_MODALITE_SEDATION',
  ACTIVITES_PROFESSIONNELLES_TYPES_ACTES = 'ACTIVITES_PROFESSIONNELLES_TYPES_ACTES',
  ACTIVITES_PROFESSIONNELLES_SEDATION = 'ACTIVITES_PROFESSIONNELLES_SEDATION',
  ACTIVITES_PROFESSIONNELLES_SEDATION_10_ANS_PLUS = 'ACTIVITES_PROFESSIONNELLES_SEDATION_10_ANS_PLUS',
  ACTIVITES_PROFESSIONNELLES_SEDATION_10_ANS_MOINS = 'ACTIVITES_PROFESSIONNELLES_SEDATION_10_ANS_MOINS',
  ACTIVITES_PROFESSIONNELLES_ANESTHESIE_10_ANS_PLUS = 'ACTIVITES_PROFESSIONNELLES_ANESTHESIE_10_ANS_PLUS',
  ACTIVITES_PROFESSIONNELLES_ANESTHESIE_10_ANS_MOINS = 'ACTIVITES_PROFESSIONNELLES_ANESTHESIE_10_ANS_MOINS',
  ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE = 'ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE',
  ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE_2 = 'ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE_2',
  ACTIVITES_PROFESSIONNELLES_SEDATION_MODEREE = 'ACTIVITES_PROFESSIONNELLES_SEDATION_MODEREE',
  ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE_MODEREE = 'ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE_MODEREE',
  ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE_MODEREE_2 = 'ACTIVITES_PROFESSIONNELLES_SEDATION_LEGERE_MODEREE_2',
  ACTIVITES_PROFESSIONNELLES_ANESTHESIE = 'ACTIVITES_PROFESSIONNELLES_ANESTHESIE',

  ACTIVITES_PROFESSIONNELLES_3D = 'ACTIVITES_PROFESSIONNELLES_3D',
  // ACTIVITES_PROFESSIONNELLES_CONDITIONS_ACTES = 'ACTIVITES_PROFESSIONNELLES_CONDITIONS_ACTES',
  ACTIVITES_PROFESSIONNELLES_ORTHESE_MANDIBULAIRE = 'ACTIVITES_PROFESSIONNELLES_ORTHESE_MANDIBULAIRE',
  ACTIVITES_PROFESSIONNELLES_IMPLANTO_PORTEE = 'ACTIVITES_PROFESSIONNELLES_IMPLANTO_PORTEE',
  ACTIVITES_PROFESSIONNELLES_TYPE_DOSSIER = 'ACTIVITES_PROFESSIONNELLES_TYPE_DOSSIER',
  ACTIVITES_PROFESSIONNELLES_TYPE_DOSSIER_LOGICIEL = 'ACTIVITES_PROFESSIONNELLES_TYPE_DOSSIER_LOGICIEL',
  ACTIVITES_PROFESSIONNELLES_TYPE_RADIO = 'ACTIVITES_PROFESSIONNELLES_TYPE_RADIO',
  ACTIVITES_PROFESSIONNELLES_TYPE_RADIO_LOGICIEL = 'ACTIVITES_PROFESSIONNELLES_TYPE_RADIO_LOGICIEL',
  ACTIVITES_PROFESSIONNELLES_RDV_LOGICIEL = 'ACTIVITES_PROFESSIONNELLES_RDV_LOGICIEL',
  ACTIVITES_PROFESSIONNELLES_FACTURATION_LOGICIEL = 'ACTIVITES_PROFESSIONNELLES_FACTURATION_LOGICIEL',
  ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_REGIONAL = 'ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_REGIONAL',
  ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_PROVINCIAL = 'ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_PROVINCIAL',
  ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_EDUCATIONAL = 'ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_EDUCATIONAL',
  ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_PROFESSIONAL = 'ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_PROFESSIONAL',
  ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_EMAIL = 'ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_EMAIL',
  ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_PUBLIC = 'ADRESSE_PROTECTION_RENSEIGNEMENTS__PERSONELS_PUBLIC',
  DECLARATION_LOGIGIEL = 'DECLARATIONS_LOGICIEL',
  ACTIVITES_PROFESSIONNELLES_NOUVEAU_DOMAINE_PRATIQUE = 'ACTIVITES_PROFESSIONNELLES_NOUVEAU_DOMAINE_PRATIQUE',
  ACTIVITES_PROFESSIONNELLES_TYPE_RADIO_LOGICIEL_SPECIFY = 'ACTIVITES_PROFESSIONNELLES_TYPE_RADIO_LOGICIEL_SPECIFY',
  ACTIVITES_PROFESSIONNELLES_TYPE_DOSSIER_LOGICIEL_SPECIFY = 'ACTIVITES_PROFESSIONNELLES_TYPE_DOSSIER_LOGICIEL_SPECIFY',
  ACTIVITES_PROFESSIONNELLES_RDV_LOGICIEL_SPECIFY = 'ACTIVITES_PROFESSIONNELLES_RDV_LOGICIEL_SPECIFY',
  ACTIVITES_PROFESSIONNELLES_RDV = 'ACTIVITES_PROFESSIONNELLES_RDV',
  ACTIVITES_PROFESSIONNELLES_RADIOLOGIE = 'ACTIVITES_PROFESSIONNELLES_RADIOLOGIE',
  ACTIVITES_PROFESSIONNELLES_NOUVEAUX_AUTISME = 'ACTIVITES_PROFESSIONNELLES_NOUVEAUX_AUTISME',
  ACTIVITES_PROFESSIONNELLES_NOUVEAUX_PATIENTS = 'ACTIVITES_PROFESSIONNELLES_NOUVEAUX_PATIENTS',
  ACTIVITES_PROFESSIONNELLES_HEURES_TRAVAILLEE = 'ACTIVITES_PROFESSIONNELLES_HEURES_TRAVAILLEE',
  ACTIVITES_PROFESSIONNELLES_FACTURATION = 'ACTIVITES_PROFESSIONNELLES_FACTURATION',
  ACTIVITES_PROFESSIONNELLES_FACTURATION_LOGICIEL_SPECIFY = 'ACTIVITES_PROFESSIONNELLES_FACTURATION_LOGICIEL_SPECIFY',
  ACTIVITES_PROFESSIONNELLES_BACKUP = 'ACTIVITES_PROFESSIONNELLES_BACKUP',
  ACTIVITES_PROFESSIONNELLES_BACKUP_STORAGE = 'ACTIVITES_PROFESSIONNELLES_BACKUP_STORAGE',
  ACTIVITES_PROFESSIONNELLES_AUTISME = 'ACTIVITES_PROFESSIONNELLES_AUTISME',
  ACTIVITES_PROFESSIONNELLES_EMPREINTE_NUMERIQUE = 'ACTIVITES_PROFESSIONNELLES_EMPREINTE_NUMERIQUE',
  ACTIVITES_PROFESSIONNELLES_TROUBLES_COGNITIFS_10_ANS_PLUS = 'ACTIVITES_PROFESSIONNELLES_TROUBLES_COGNITIFS_10_ANS_PLUS',
  ACTIVITES_PROFESSIONNELLES_TROUBLES_COGNITIFS_10_ANS_MOINS = 'ACTIVITES_PROFESSIONNELLES_TROUBLES_COGNITIFS_10_ANS_MOINS',
  ACTIVITES_PROFESSIONNELLES_PERTE_MOBILITE_10_ANS_PLUS = 'ACTIVITES_PROFESSIONNELLES_PERTE_MOBILITE_10_ANS_PLUS',
  ACTIVITES_PROFESSIONNELLES_PERTE_MOBILITE_10_ANS_MOINS = 'ACTIVITES_PROFESSIONNELLES_PERTE_MOBILITE_10_ANS_MOINS',
  ACTIVITES_PROFESSIONNELLES_CONSENTEMENT_TROUVER_DENTISTE = 'ACTIVITES_PROFESSIONNELLES_CONSENTEMENT_TROUVER_DENTISTE',
  ACTIVITES_PROFESSIONNELLES_HEURES_TRAVAILLEE_REGION_ADMIN = 'ACTIVITES_PROFESSIONNELLES_HEURES_TRAVAILLEE_REGION_ADMIN',
  ACTIVITES_PROFESSIONNELLES_HEURES_TRAVAILLEE_REGION_ADMIN_ANNEE_PRECEDENTE = 'ACTIVITES_PROFESSIONNELLES_HEURES_TRAVAILLEE_REGION_ADMIN_ANNEE_PRECEDENTE',
  // ...
}

export interface LocalizedString {
  fr: string;
  en: string;
}


export interface DynamicQuestion {
  id: string,
  questionNumber: number,
  year: number,
  dataType: QuestionDataType,
  section?: SectionFormulaire,
  editLabel: LocalizedString,
  summaryLabel: LocalizedString,
  isActive: boolean,
  isRequired?: boolean;
  sequenceNumber?: number;    //optional ordering of the question, nulls/undefined are appended at the end
  code?: string;              //additional parameter to help UI mamage the question (ex: case when same label applies 2 questions, Milieu clinique et milieu hospitalier).
  isAdhocQuestion?: boolean;          // question where datetype id set, and are laid out at the end of the section
};

export interface WorkHour {
  clinicAddresse: string;
  periodStartDate: Date;
  periodEndDate: Date;
  asOf: string;
  asOfOther: string;
  clinicalActivity: boolean;
  numberOFWeeks: number;
  numberOfHoursAWeek: number;
  totalHours?: number;
  declarationPeriod: string;
  chairPracticeHoursByWeek?: number;
  city?: string;
  clinicId: string;
}

export interface ProceedInscriptionPaymentDto {
  amount: string;
  dataKey: string;
  year: number;
  voluntaryContribution: number;
  formId: string;
  language: string;
  nameUnderCard: string;

  memberId?: string;
  isResubscription?: boolean;
  period?: string;
  validFromDate?: Date;
  validToDate?: Date;

  isAnnualCampaign: boolean;
}

export interface PaymentReceipt {
  amount: string;
  authorizationNumber: string;
  creditCardNumber: string;
  date: string;
  message: string;
  monerisCardType: string;
  monerisTransactionTypeRef: string;
  nameUnderCard: string;
  orderId: string;
  referenceNumber: string;
  respondentPermitNumber: string;
  responseCode: string;
  transactionResult: string;
  payByCheque?: boolean;
}

export class MemberDocumentToAdd {
  documentTypeId: string;
  note: string;
  file: File;
  uploadedByUserId: string;
}

export interface CheckPaymentDto {
  amount: string;
  year: number;
  voluntaryContribution: number;
  formId: string;
  payByCheque: boolean,
  isResubscription: boolean,
  validFromDate: Date,
  validToDate: Date,
  isAnnualCampaign: boolean
}